// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as ReactModal from "react-modal";
import * as NextImage$PorterinFeature from "../../../../ui/components/NextImage.mjs";
import * as LocalStorage$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/helpers/LocalStorage.mjs";
import * as CityContext$PorterinFeature from "../../../../contexts/city-context/CityContext.mjs";
import * as CommonVehicleHelper$PorterinFeature from "../../../core/helpers/CommonVehicleHelper.mjs";
import * as CitySelectorModalModuleScss from "../styles/CitySelectorModal.module.scss";

var styles = CitySelectorModalModuleScss;

var modalStyles = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.3)"
  }
};

function CitySelectorModalCmp(Props) {
  var modalState = Props.modalState;
  var close_modal = Props.close_modal;
  var city_selector_data = Props.city_selector_data;
  var close_icon = Props.close_icon;
  var city_title_desc = Props.city_title_desc;
  var citySelectedContext = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  return React.createElement(ReactModal, {
              isOpen: modalState,
              onRequestClose: close_modal,
              closeTimeoutMS: 500,
              style: modalStyles,
              className: styles["city-picker-modal"],
              ariaHideApp: false,
              shouldCloseOnOverlayClick: true,
              children: React.createElement("div", {
                    className: styles.container
                  }, React.createElement("div", {
                        className: styles["header-container"]
                      }, React.createElement("div", {
                            className: styles["close-button"],
                            onClick: (function (param) {
                                Curry._1(close_modal, undefined);
                              })
                          }, React.createElement(NextImage$PorterinFeature.make, {
                                src: close_icon.path,
                                height: 24.0,
                                width: 24.0,
                                quality: 100.0,
                                alt: close_icon.alt_text
                              })), React.createElement("div", {
                            className: styles.title
                          }, city_title_desc.text)), React.createElement("div", {
                        className: styles["cities-list-container"]
                      }, Belt_Array.map(CommonVehicleHelper$PorterinFeature.sortCityServicesByName(city_selector_data), (function (city_data) {
                              return React.createElement("div", {
                                          key: city_data.city_name,
                                          className: styles["city-container"],
                                          onClick: (function (param) {
                                              var city = city_data.city_name;
                                              var city_label = city_data.city_label;
                                              Curry._2(citySelectedContext.set_city_selected, city.toLocaleLowerCase(), city_label);
                                              Curry._1(close_modal, undefined);
                                              LocalStorage$PorterinUtils.updateUserCity(city);
                                            })
                                        }, React.createElement("div", {
                                              className: styles["city-image"]
                                            }, React.createElement(NextImage$PorterinFeature.make, {
                                                  src: city_data.city_image.path,
                                                  height: 80.0,
                                                  width: 80.0,
                                                  quality: 100.0,
                                                  alt: city_data.city_image.alt_text
                                                })), React.createElement("div", {
                                              className: styles["city-title"]
                                            }, city_data.city_name));
                            }))))
            });
}

var make = CitySelectorModalCmp;

var $$default = CitySelectorModalCmp;

export {
  styles ,
  modalStyles ,
  make ,
  $$default ,
  $$default as default,
}
/* styles Not a pure module */
